import type { ReactNode } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import styles from "./CarouselTile.module.scss";

interface CarouselTileProps {
  className?: string;
  children: ReactNode;
}

export const CarouselTile = ({ className, children }: CarouselTileProps) => {
  const [block] = useModuleBEM(styles, "CarouselTile");
  return <div className={clsx(block, className)}>{children}</div>;
};

interface TileImageContainerProps {
  className?: string;
  children: ReactNode;
}

export const TileImageContainer = ({
  className,
  children,
}: TileImageContainerProps) => {
  const [, cn] = useModuleBEM(styles, "CarouselTile");
  return (
    <div className={clsx(cn("imageContainer"), className)}>{children}</div>
  );
};

interface TileImageProps {
  src: string;
  alt: string;
  className?: string;
}

export const TileImage = ({ src, alt, className }: TileImageProps) => {
  const [, cn] = useModuleBEM(styles, "CarouselTile");
  return <img className={clsx(cn("image"), className)} src={src} alt={alt} />;
};

interface TileContentProps {
  className?: string;
  children: ReactNode;
}

export const TileContent = ({ className, children }: TileContentProps) => {
  const [, cn] = useModuleBEM(styles, "CarouselTile");
  return <div className={clsx(cn("content"), className)}>{children}</div>;
};
